import React, { useEffect, useState } from 'react'
import { Link } from 'gatsby'
import { useAuth0 } from '@auth0/auth0-react'
import {
  Popover,
  PopoverHandler,
  PopoverContent,
  Typography,
  List,
  ListItem,
  ListItemPrefix,
  Button,
} from '@material-tailwind/react'
import { CgMail, CgMenuBoxed, CgLogOff, CgProfile } from 'react-icons/cg'
import './index.less'

const AccountButton = () => {
  const {
    loginWithRedirect,
    getAccessTokenSilently,
    logout,
    user,
    isAuthenticated,
  } = useAuth0()
  const [openPopover, setOpenPopover] = React.useState(false)
  const [shopifyCustomer, setShopifyCustomer] = useState(null)
  const [isLoading, setIsLoading] = useState(false)

  const triggers = {
    onClick: () => setOpenPopover(!openPopover),
  }
  const onLogout = () => {
    logout({ logoutParams: { returnTo: window.location.origin } })
    setShopifyCustomer(null)
  }
  return (
    <Popover open={openPopover} handler={setOpenPopover} placement="bottom-end">
      {
        <PopoverHandler
          {...triggers}
          className="cursor-pointer inline-block relative object-cover object-center !rounded-full rounded-lg ml-3 inline-flex items-center gap-1"
        >
          {!isAuthenticated ? (
            <button>
              <CgProfile className="text-fluid-md text-[var(--text-color-secondary)] hover:text-black" />
            </button>
          ) : (
            <div>
              <img
                src={user?.picture}
                alt={user?.name || 'User Avatar'}
                className="w-5 h-5 rounded-full border border-gray-200 hover:border-gray-300 transition-colors cursor-pointer mr-1"
                onError={(e) => {
                  e.target.style = 'display: none;'
                }}
                title={user?.name || user?.email}
                loading="lazy"
              />
              <button>{user?.name}</button>
            </div>
          )}
        </PopoverHandler>
      }
      <PopoverContent className="w-72 z-[1001]" {...triggers}>
        {isAuthenticated && (
          <div className="mb-4 px-3 flex items-center gap-4 border-b border-blue-gray-50 pb-4">
            <div>
              <Typography variant="h6" color="blue-gray">
                {user.name}
              </Typography>
              <Typography
                variant="small"
                color="gray"
                className="font-medium text-blue-gray-500"
              >
                {user?.nickname}
              </Typography>
              {isLoading && (
                <Typography variant="small" color="blue" className="mt-1">
                  Loading...
                </Typography>
              )}
            </div>
          </div>
        )}
        <List className="p-0">
          {isAuthenticated && (
            <React.Fragment>
              <Link to="/account">
                <ListItem>
                  <ListItemPrefix>
                    <CgMenuBoxed />
                  </ListItemPrefix>
                  Account
                </ListItem>
              </Link>
              <ListItem onClick={onLogout}>
                <ListItemPrefix>
                  <CgLogOff />
                </ListItemPrefix>
                <button aria-label="log out">Log out</button>
              </ListItem>
            </React.Fragment>
          )}
          {!isAuthenticated && (
            <ListItem onClick={() => loginWithRedirect()}>
              <ListItemPrefix>
                <CgLogOff />
              </ListItemPrefix>
              <button aria-label="sign in">Sign in</button>
            </ListItem>
          )}
        </List>
      </PopoverContent>
    </Popover>
  )
}

export default AccountButton
